import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import TestimonialHero from '../components/testimonialhero';
import Header from '../components/header';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function TestimonialsView() {
  useDocumentTitle('Testimonials-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      {/* <Breadcrumb image={'bg-image-25'} title={'Testimonials'} />*/}
      <TestimonialHero />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="color-border mb-3 mt-5"></div>
          <div className="row">
            <div className="col-lg-8">
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  Caring defines us and our work. People receiving care expect
                  it to be right for them, consistently, throughout every stage
                  of their life
                </p>
                <p>
                  Take a look through our client and staff testimonials below.
                </p>
                <p>
                  If you’d like to leave us a testimonial, please get in touch.
                  We’d love to hear from you!
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with-us">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/training">
                        Training
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/reward">
                        Reward and Recognition
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div className="ltn__feature-area mt-2">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-sm-6 col-12 bg-quote">
              <div className="ltn__feature-item ltn__feature-item-61 text-center bg-lemon  box-shadow-1">
                <div className="ltn__feature-info">
                  <p>
                    {' '}
                    The management team are friendly and easily accessible. They
                    run a company which provides a flexible service at a
                    competitive price.
                  </p>
                  <p>Micheal H.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-sm-6 col-12 bg-quote">
              <div className="ltn__feature-item ltn__feature-item-61 text-center">
                <div className="ltn__feature-info"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ltn__feature-area section-bg-1 mt-2">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-2 col-sm-6 col-12 bg-quote">
              <div className="ltn__feature-item ltn__feature-item-61 text-center">
                <div className="ltn__feature-info"></div>
              </div>
            </div>
            <div className="col-lg-10 col-sm-6 col-12 bg-quote">
              <div className="ltn__feature-item ltn__feature-item-61 text-center bg-main  box-shadow-1">
                <div className="ltn__feature-info">
                  <p> All staff are kind and friendly!</p>
                  <p>Ade & Winnie</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ltn__feature-area section-bg-1 mt-2">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-sm-6 col-12 bg-quote">
              <div className="ltn__feature-item ltn__feature-item-61 text-center bg-lemon  box-shadow-1">
                <div className="ltn__feature-info">
                  <p> I get on well with all my carers!</p>
                  <p>David W</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-sm-6 col-12 bg-quote">
              <div className="ltn__feature-item ltn__feature-item-61 text-center">
                <div className="ltn__feature-info"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ltn__feature-area section-bg-1 mt-2">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-2 col-sm-6 col-12 bg-quote">
              <div className="ltn__feature-item ltn__feature-item-61 text-center">
                <div className="ltn__feature-info"></div>
              </div>
            </div>
            <div className="col-lg-10 col-sm-6 col-12 mb-5">
              <div className="ltn__feature-item ltn__feature-item-61 text-center bg-main  box-shadow-1">
                <div className="ltn__feature-info">
                  <p> I am really happy with the carer and my son loves her!</p>
                  <p>Sheena</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CallToAction />
      <Footer />
    </div>
  );
}

export default TestimonialsView;
